<template>
	<div id="community-select">
		<node-list
			v-slot="{ item, active }"
			:items="communities"
			:active-item="selectedCommunity"
			:loading="loading"
			:search-label="strings.community.select"
			@click="setCommunity"
		>
			<v-list-item-icon>
				<group-icon :group="item" />
			</v-list-item-icon>

			<v-list-item-content>
				<v-list-item-title v-text="item.name" />
			</v-list-item-content>

			<div v-if="active">
				<v-list-item-action-text v-text="strings.community.current" />
				<v-list-item-action>
					<v-icon small color="orange">fa-eye</v-icon>
				</v-list-item-action>
			</div>
		</node-list>
	</div>
</template>

<style lang="scss" scoped>
.selection-row {
	align-self: start;
}

#community .list-item.active {
	// NOTE: Due to libsass bug, can't use `var(--v-orange-base)` inside of rgba function.
	background-color: rgba(orange, 0.1);
}
</style>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";

import strings from "@/utils/strings";

export default {
	data: () => ({
		strings: strings.dashboard,
		loading: false,
	}),

	computed: {
		...mapGetters({
			$communities: "communities/items",
			selectedCommunity: "session/community",
		}),

		communities() {
			return _.filter(this.$communities, community =>
				this.$can("read", community)
			);
		},
	},

	methods: {
		...mapActions({
			setCommunityId: "session/setCommunityId"
		}),

		async setCommunity(community) {

			await this.setCommunityId(community);

			const next = this.$route.meta.next
				? {
						...this.$route.meta.next,
						params: { communityId: community.id },
				  }
				: {
						path: `${community.id}`,
						append: true,
				  };
			return this.$router.push(next);
		},
	},
};
</script>
